import { gql } from '@apollo/client';

export function overridePolicyPlanCover() {
  return gql`
    mutation overridePolicyPlanCover(
      $policyPlanCoverVarianceId: String!
      $ExcessDaysVariance: Decimal
      $ExcessPercentageVariance: Decimal
      $ExcessValueVariance: Decimal
      $PremiumPercentageVariance: Decimal
      $PremiumValueVariance: Decimal
      $SumInsuredVariance: Decimal!
    ) {
      production {
        actions {
          overridePolicyPlanCover(
            policyPlanCoverVarianceId: $policyPlanCoverVarianceId
            ExcessDaysVariance: $ExcessDaysVariance
            ExcessPercentageVariance: $ExcessPercentageVariance
            ExcessValueVariance: $ExcessValueVariance
            PremiumPercentageVariance: $PremiumPercentageVariance
            PremiumValueVariance: $PremiumValueVariance
            SumInsuredVariance: $SumInsuredVariance
          ) {
            id
          }
        }
      }
    }
  `;
}
